/* tslint:disable:max-line-length */
import { PublishedFormId } from './FormId';
import { PublishedProjectId } from './ProjectId';

export const majorProjects: Array<`${PublishedProjectId}`> = [
    PublishedProjectId.DiningTableHighTableBarTable,
    PublishedProjectId.KitchenBuild,
    PublishedProjectId.CustomWorkPlan,
    PublishedProjectId.Desk,
    PublishedProjectId.CustomWardrobe,
    PublishedProjectId.CounterBar,
    PublishedProjectId.Stairs,
    PublishedProjectId.Guardrail,
    PublishedProjectId.CustomLibrary,
    PublishedProjectId.HouseInteriorLayoutAndFurniture,
    PublishedProjectId.Claustra,
    PublishedProjectId.CustomGlassWall,
];

export const projects: Readonly<{ [key in PublishedProjectId]: PublishedFormId[] }> = {
    [PublishedProjectId.Default]: [
        PublishedFormId.Default],
    [PublishedProjectId.WindowAndDoorWindow]: [
        PublishedFormId.Windows,
        PublishedFormId.FrenchWindow,
        PublishedFormId.RoofWindow],
    [PublishedProjectId.SlidingBayWindow]: [
        PublishedFormId.SlidingBayWindow,
        PublishedFormId.Windows],
    [PublishedProjectId.FrontDoorAndService]: [
        PublishedFormId.HighWind,
        PublishedFormId.FrontDoor,
        PublishedFormId.ServiceDoor,
        PublishedFormId.InteriorDoor,
        PublishedFormId.CustomExteriorDoor],
    [PublishedProjectId.ShutterAndAwning]: [
        PublishedFormId.SunBreeze,
        PublishedFormId.InteriorShutter,
        PublishedFormId.ExteriorShutter,
        PublishedFormId.CustomBlind,
        PublishedFormId.CustomBlindOutdoor],
    [PublishedProjectId.PortalAndGate]: [
        PublishedFormId.Portal],
    [PublishedProjectId.DelimitationAndFence]: [
        PublishedFormId.Fencing,
        PublishedFormId.Claustras,
        PublishedFormId.GrillageRigide,
        PublishedFormId.Balustrade,
        PublishedFormId.Fence],
    [PublishedProjectId.LayoutAndBuildOfPoolHouse]: [
        PublishedFormId.LayoutAndBuildOfPoolHouse],
    [PublishedProjectId.PorchDesignAndLayout]: [
        PublishedFormId.PorchDesignAndLayout],
    [PublishedProjectId.DesignAndBuildOfGardenSheds]: [
        PublishedFormId.GardenShelter],
    [PublishedProjectId.ArborDesignAndBuild]: [
        PublishedFormId.Tonelle],
    [PublishedProjectId.Blinds]: [
        PublishedFormId.SunBreeze,
        PublishedFormId.CustomBlind,
        PublishedFormId.CustomBlindOutdoor],
    [PublishedProjectId.InteriorDoor]: [
        PublishedFormId.InteriorDoor],
    [PublishedProjectId.CustomGlassWall]: [
        PublishedFormId.GlassWall],
    [PublishedProjectId.PartitionWall]: [
        PublishedFormId.PartitionWall,
        PublishedFormId.Claustras,
        PublishedFormId.PalisadeAndClaustra],
    [PublishedProjectId.TerraceDesignAndBuild]: [
        PublishedFormId.TerraceWood,
        PublishedFormId.TerraceStones],
    [PublishedProjectId.CustomWardrobe]: [
        PublishedFormId.WardrobeRoom],
    [PublishedProjectId.BuffetAndSideboard]: [
        PublishedFormId.DresserSideboard],
    [PublishedProjectId.OfficePedestals]: [
        PublishedFormId.OfficePedestals],
    [PublishedProjectId.Trunk]: [
        PublishedFormId.Trunk],
    [PublishedProjectId.ChestsOfDrawersAndCabinet]: [
        PublishedFormId.ChestsOfDrawersAndCabinet],
    [PublishedProjectId.CustomShelves]: [
        PublishedFormId.Shelf,
        PublishedFormId.ShelfShoes],
    [PublishedProjectId.Storage]: [
        PublishedFormId.CustomStorage,
        PublishedFormId.StorageUnderStairs,
        PublishedFormId.ShoesCabinet,
        PublishedFormId.ShelfShoes],
    [PublishedProjectId.CustomKitchenCupboard]: [
        PublishedFormId.StorageCupboard],
    [PublishedProjectId.ClosetDoor]: [
        PublishedFormId.CustomCupboard],
    [PublishedProjectId.CustomCupboard]: [
        PublishedFormId.CustomCupboard,
        PublishedFormId.StorageCupboard],
    [PublishedProjectId.CustomPantry]: [
        PublishedFormId.CustomPantry],
    [PublishedProjectId.WineCellarDesignAndLayout]: [
        PublishedFormId.DpWineCellar,
        PublishedFormId.WineCellarDedicatedRoom,
        PublishedFormId.WineCellar],
    [PublishedProjectId.HallwayCabinetAndShoes]: [
        PublishedFormId.HallCabinet,
        PublishedFormId.ShoesCabinet,
        PublishedFormId.ShelfShoes,
        PublishedFormId.BenchAndStool,
        PublishedFormId.CoatHanger],
    [PublishedProjectId.TvUnit]: [
        PublishedFormId.TvUnitStand,
        PublishedFormId.TvUnitSuspended],
    [PublishedProjectId.DiningTableHighTableBarTable]: [
        PublishedFormId.TableLiveEdge,
        PublishedFormId.TableRiverTable,
        PublishedFormId.TableFarm,
        PublishedFormId.MeetingTable,
        PublishedFormId.TableConcrete,
        PublishedFormId.TableIndustrial,
        PublishedFormId.TableMarbleAndStone,
        PublishedFormId.TableMikado,
        PublishedFormId.Table,
        PublishedFormId.TableScandinavian,
        PublishedFormId.TableVintage,
        PublishedFormId.TableLegs,
        PublishedFormId.Tray],
    [PublishedProjectId.LowTable]: [
        PublishedFormId.LowTable,
        PublishedFormId.LowTableNesting,
        PublishedFormId.LowTableNoLegs,
        PublishedFormId.LowTableNestingNoLegs],
    [PublishedProjectId.SideTableAndBedsideTable]: [
        PublishedFormId.SofaAndpedestalTable,
        PublishedFormId.Nightstand],
    [PublishedProjectId.CounterBar]: [
        PublishedFormId.CounterBar,
        PublishedFormId.CounterBarCurved,
        PublishedFormId.CounterBarAngle,
        PublishedFormId.CounterBar,
        PublishedFormId.CounterBarCentral],
    [PublishedProjectId.DressingTable]: [
        PublishedFormId.DressingTable],
    [PublishedProjectId.SofaAndPedestalTable]: [
        PublishedFormId.SofaAndpedestalTable,
        PublishedFormId.LowTable,
        PublishedFormId.LowTableNesting,
        PublishedFormId.LowTableNoLegs,
        PublishedFormId.LowTableNestingNoLegs],
    [PublishedProjectId.Console]: [
        PublishedFormId.Console,
        PublishedFormId.ConsoleSuspended],
    [PublishedProjectId.BenchAndStool]: [
        PublishedFormId.Bench,
        PublishedFormId.Stool],
    [PublishedProjectId.BenchAndBenchSeat]: [
        PublishedFormId.Bench],
    [PublishedProjectId.Pouf]: [
        PublishedFormId.Pouf],
    [PublishedProjectId.Sofa]: [
        PublishedFormId.Sofa],
    [PublishedProjectId.EndOfBed]: [
        PublishedFormId.EndOfBed],
    [PublishedProjectId.BarChairAndStool]: [
        PublishedFormId.BarChair,
        PublishedFormId.BarStool],
    [PublishedProjectId.ChairAndArmchair]: [
        PublishedFormId.Chair,
        PublishedFormId.Armchair],
    [PublishedProjectId.CustomBed]: [
        PublishedFormId.CustomBeds,
        PublishedFormId.CustomBunkBed,
        PublishedFormId.CustomMezzanine],
    [PublishedProjectId.Bedhead]: [
        PublishedFormId.Bedhead],
    [PublishedProjectId.StoneLaying]: [
        PublishedFormId.StoneLaying],
    [PublishedProjectId.Nightstand]: [
        PublishedFormId.Nightstand,
        PublishedFormId.CustomBeds,
        PublishedFormId.CustomBunkBed,
        PublishedFormId.CustomMezzanine],
    [PublishedProjectId.BedroomDesign]: [
        PublishedFormId.CustomMezzanine,
        PublishedFormId.BedroomDesign,
        PublishedFormId.BedroomLayout,
        PublishedFormId.ChildBedroomLayout,
        PublishedFormId.CustomBeds,
        PublishedFormId.CustomBunkBed],
    [PublishedProjectId.ChildrenBedroomDesign]: [
        PublishedFormId.ChildBedroomLayout,
        PublishedFormId.CustomBeds,
        PublishedFormId.CustomBunkBed,
        PublishedFormId.CustomMezzanine],
    [PublishedProjectId.BedroomLayout]: [
        PublishedFormId.BedroomLayout,
        PublishedFormId.ChildBedroomLayout,
        PublishedFormId.CustomBeds,
        PublishedFormId.CustomBunkBed],
    [PublishedProjectId.KitchenBuild]: [
        PublishedFormId.KitchenDesign],
    [PublishedProjectId.OutdoorKitchenBuild]: [
        PublishedFormId.OutdoorKitchenBuild,
        PublishedFormId.CustomKitchenCabinet,
        PublishedFormId.CustomKitchenBaseCabinet,
        PublishedFormId.KitchenIsland],
    [PublishedProjectId.CustomKitchenCabinet]: [
        PublishedFormId.CustomKitchenCabinet],
    [PublishedProjectId.CustomKitchenBaseCabinet]: [
        PublishedFormId.CustomKitchenBaseCabinet],
    [PublishedProjectId.KitchenIsland]: [
        PublishedFormId.KitchenIsland],
    [PublishedProjectId.CustomLight]: [
        PublishedFormId.Light],
    [PublishedProjectId.WallPaneling]: [
        PublishedFormId.WallPaneling],
    [PublishedProjectId.GreenWall]: [
        PublishedFormId.VegetalWall],
    [PublishedProjectId.ShowerDoor]: [
        PublishedFormId.ShowerScreen],
    [PublishedProjectId.ShopLayoutAndFurniture]: [
        PublishedFormId.DpPharmacy,
        PublishedFormId.DpRealEstate,
        PublishedFormId.DpButcherShop,
        PublishedFormId.DpBakery,
        PublishedFormId.DpGrocery,
        PublishedFormId.DpCheeseDairy,
        PublishedFormId.DpBeautyInstitute,
        PublishedFormId.DpHairdresser,
        PublishedFormId.DpShop,
        PublishedFormId.ReceptionDesk,
        PublishedFormId.Showcase,
        PublishedFormId.SalesTable,
        PublishedFormId.StorageCabinet,
        PublishedFormId.Shelving,
        PublishedFormId.Row,
        PublishedFormId.Teaches,
        PublishedFormId.Light,
        PublishedFormId.Chair,
        PublishedFormId.Armchair,
        PublishedFormId.Mirror,
        PublishedFormId.Ground,
        PublishedFormId.WineCellar,
        PublishedFormId.BenchAndStool,
        PublishedFormId.GreenWall,
        PublishedFormId.SalesCounter],
    [PublishedProjectId.CHRLayoutAndFurniture]: [
        PublishedFormId.DpFastFood,
        PublishedFormId.DpBar,
        PublishedFormId.ReceptionDesk,
        PublishedFormId.Showcase,
        PublishedFormId.SalesTable,
        PublishedFormId.StorageCabinet,
        PublishedFormId.Shelving,
        PublishedFormId.Row,
        PublishedFormId.Teaches,
        PublishedFormId.Light,
        PublishedFormId.Chair,
        PublishedFormId.Armchair,
        PublishedFormId.Mirror,
        PublishedFormId.Ground,
        PublishedFormId.WineCellar,
        PublishedFormId.BenchAndStool,
        PublishedFormId.GreenWall,
        PublishedFormId.CustomCabinet,
        PublishedFormId.DpHotel,
        PublishedFormId.GlassWall,
        PublishedFormId.KitchenDesign,
        PublishedFormId.CounterBar,
        PublishedFormId.CounterBarCentral,
        PublishedFormId.CounterBarCurved,
        PublishedFormId.CounterBarAngle,
        PublishedFormId.CustomMezzanine,
        PublishedFormId.Bedhead,
        PublishedFormId.Sofa,
        PublishedFormId.EatStandingUp,
        PublishedFormId.Bench,
        PublishedFormId.Table,
        PublishedFormId.CustomBeds,
        PublishedFormId.CustomBunkBed,
        PublishedFormId.WardrobeRoom,
        PublishedFormId.StorageCupboard,
        PublishedFormId.ShowerScreen,
        PublishedFormId.SalesCounter,
        PublishedFormId.Claustras,
        PublishedFormId.Sunbath,
        PublishedFormId.DpRestaurant,
        PublishedFormId.Stool,
        PublishedFormId.CustomPantry,
        PublishedFormId.LibraryComposition],
    [PublishedProjectId.WorkspaceLayoutAndFurniture]: [
        PublishedFormId.DpEvents,
        PublishedFormId.DpWorkspace,
        PublishedFormId.Desk,
        PublishedFormId.Table,
        PublishedFormId.Chair,
        PublishedFormId.Armchair,
        PublishedFormId.Stool,
        PublishedFormId.LibraryComposition,
        PublishedFormId.StorageCabinet,
        PublishedFormId.OfficePedestals,
        PublishedFormId.CustomCabinet,
        PublishedFormId.Claustras,
        PublishedFormId.PartitionWall,
        PublishedFormId.PhoneBox,
        PublishedFormId.Ground,
        PublishedFormId.ReceptionDesk,
        PublishedFormId.Sofa,
        PublishedFormId.Bench,
        PublishedFormId.Pouf,
        PublishedFormId.Teaches],
    [PublishedProjectId.HouseOutsideLayoutAndFurniture]: [
        PublishedFormId.Sunbath,
        PublishedFormId.Claustras,
        PublishedFormId.PartitionWall,
        PublishedFormId.Fencing,
        PublishedFormId.Portal,
        PublishedFormId.TerraceStones,
        PublishedFormId.TerraceWood,
        PublishedFormId.DpHouseOutside,
        PublishedFormId.HighWind,
        PublishedFormId.PergolaBioclimatic,
        PublishedFormId.PergolaClassic,
        PublishedFormId.Veranda,
        PublishedFormId.Fence,
        PublishedFormId.Portal,
        PublishedFormId.Table,
        PublishedFormId.Chair,
        PublishedFormId.OutdoorKitchenBuild,
        PublishedFormId.GlassWall],
    [PublishedProjectId.HouseInteriorLayoutAndFurniture]: [
        PublishedFormId.KitchenDesign,
        PublishedFormId.Bedhead,
        PublishedFormId.ShelfShoes,
        PublishedFormId.ShoesCabinet,
        PublishedFormId.LowTable,
        PublishedFormId.LowTableNesting,
        PublishedFormId.LowTableNestingNoLegs,
        PublishedFormId.LowTableNoLegs,
        PublishedFormId.CustomMezzanine,
        PublishedFormId.Claustras,
        PublishedFormId.PartitionWall,
        PublishedFormId.DpHouseInterior,
        PublishedFormId.StaircaseQuarterTurn,
        PublishedFormId.StaircaseHalfTurn,
        PublishedFormId.StaircaseSpiralSquare,
        PublishedFormId.StaircaseSpiralRound,
        PublishedFormId.StaircaseTurnLanding,
        PublishedFormId.StaircaseStraight,
        PublishedFormId.StaircaseDesign,
        PublishedFormId.Table,
        PublishedFormId.TvUnitStand,
        PublishedFormId.TvUnitSuspended,
        PublishedFormId.Console,
        PublishedFormId.LibraryComposition,
        PublishedFormId.ChestsOfDrawersAndCabinet,
        PublishedFormId.ShoesCabinet,
        PublishedFormId.CustomCupboard,
        PublishedFormId.FrontDoor,
        PublishedFormId.Chair,
        PublishedFormId.Armchair,
        PublishedFormId.Sofa,
        PublishedFormId.Ground,
        PublishedFormId.CustomPantry,
        PublishedFormId.KitchenDesign,
        PublishedFormId.Worktop,
        PublishedFormId.BarChair,
        PublishedFormId.Stool,
        PublishedFormId.Bench,
        PublishedFormId.GlassWall,
        PublishedFormId.StorageCabinet,
        PublishedFormId.Mirror,
        PublishedFormId.ShowerScreen,
        PublishedFormId.CustomMadeVanityUnit,
        PublishedFormId.WardrobeRoom,
        PublishedFormId.CustomBeds,
        PublishedFormId.CustomBunkBed,
        PublishedFormId.LibraryComposition,
        PublishedFormId.CustomCabinet,
        PublishedFormId.Desk,
        PublishedFormId.OfficePedestals],
    [PublishedProjectId.Claustra]: [
        PublishedFormId.Claustras],
    [PublishedProjectId.CustomBuiltInCabinet]: [
        PublishedFormId.CustomBuiltInCabinet],
    [PublishedProjectId.CustomCurtainAndVeil]: [
        PublishedFormId.CustomCurtainAndVeil],
    [PublishedProjectId.CustomGarageDoor]: [
        PublishedFormId.GarageDoor],
    [PublishedProjectId.CustomLibrary]: [
        PublishedFormId.LibraryComposition],
    [PublishedProjectId.CustomRugs]: [
        PublishedFormId.CustomRugs],
    [PublishedProjectId.CustomWorkPlan]: [
        PublishedFormId.Worktop,
        PublishedFormId.WorktopAssembled],
    [PublishedProjectId.Desk]: [
        PublishedFormId.Desk,
        PublishedFormId.DeskExecutive,
        PublishedFormId.MeetingTable,
        PublishedFormId.DpWorkspace],
    [PublishedProjectId.WallHanging]: [
        PublishedFormId.WallHanging],
    [PublishedProjectId.VerandaDesignAndBuild]: [
        PublishedFormId.Veranda],
    [PublishedProjectId.Stairs]: [
        PublishedFormId.StaircaseQuarterTurn,
        PublishedFormId.StaircaseHalfTurn,
        PublishedFormId.StaircaseSpiralSquare,
        PublishedFormId.StaircaseSpiralRound,
        PublishedFormId.StaircaseTurnLanding,
        PublishedFormId.StaircaseStraight],
    [PublishedProjectId.Guardrail]: [
        PublishedFormId.Fence],
    [PublishedProjectId.PergolaConstruction]: [
        PublishedFormId.DpHouseOutside,
        PublishedFormId.PergolaBioclimatic,
        PublishedFormId.PergolaClassic],
    [PublishedProjectId.Mirror]: [
        PublishedFormId.Mirror],
    [PublishedProjectId.GlassWindowGlazingAndMirrorCutting]: [
        PublishedFormId.GlassShape,
        PublishedFormId.Mirror],
    [PublishedProjectId.GreenhouseBuild]: [
        PublishedFormId.GlassGreenHouse],
    [PublishedProjectId.InstallationOfCredenza]: [
        PublishedFormId.Credenza],
    [PublishedProjectId.GardenPavilionDesignAndBuild]: [
        PublishedFormId.GardenPavilionDesignAndBuild],
    [PublishedProjectId.SwimmingPoolBuild]: [
        PublishedFormId.SwimmingPoolBuild,
        PublishedFormId.PoolDeckDesignAndLayout],
    [PublishedProjectId.SwimingPoolLightingInstallation]: [
        PublishedFormId.SwimingPoolLightingInstallation],
    [PublishedProjectId.PoolDeckDesignAndLayout]: [
        PublishedFormId.PoolDeckDesignAndLayout],
    [PublishedProjectId.AboveGroundPool]: [
        PublishedFormId.AboveGroundPool],
    [PublishedProjectId.MeetingTable]: [
        PublishedFormId.MeetingTable],
    [PublishedProjectId.KitchenBack]: [
        PublishedFormId.KitchenBack],
};

export default projects;
